import {
    IconActivity,
    IconBolt,
    IconBrain, IconCalendar,
    IconClock, IconFileText,
    IconNotes,
    IconTemplate,
    IconUser,
    IconUsers
} from "@tabler/icons-react";
import {Box, BoxProps, MantineColor, StyleProp} from "@mantine/core";


export const DashboardColors: { [key: string]: StyleProp<MantineColor> } = {
    megScan: "pink.5",
    eegScan: "pink.5",
    stimulations: "cyan.5",
    subjects: "grape.5",
    duration: "blue.5",
    trendingUp: "green.5",
    trendingDown: "red.5",
    notes: "gray.5",
    activity: "green.5",
    template: "gray.5",
    fileText: "gray.5",
    sessions: "yellow.5",
    calendar: "gray.5",
}

interface DashboardIconProps extends  Omit<BoxProps,"size"> {
    size?: string | number
}

const centerAlignStyle = {
    display:"grid",
    grid: "auto / auto",
    alignItems:"center",
}
export const DashboardIcons = {
    megScanIcon: (props?: DashboardIconProps) => <Box style={centerAlignStyle} {...props} c={props?.c || DashboardColors.megScan}><IconBrain
        size={props?.size || "1.5em"} /></Box>,
    eegScanIcon: (props?: DashboardIconProps) => <Box style={centerAlignStyle} {...props} c={props?.c || DashboardColors.eegScan}><IconBrain
        size={props?.size || "1.5em"} /></Box>,
    subjectsIcon: (props?: DashboardIconProps) => <Box style={centerAlignStyle} {...props} c={props?.c || DashboardColors.subjects}><IconUsers
        size={props?.size || "1.5em"}/></Box>,
    subjectIcon: (props?: DashboardIconProps) => <Box style={centerAlignStyle} {...props} c={props?.c || DashboardColors.subjects}><IconUser
        size={props?.size || "1.5em"} /></Box>,
    stimulationsIcon: (props?: DashboardIconProps) => <Box style={centerAlignStyle} {...props} c={props?.c || DashboardColors.stimulations}><IconBolt
        size={props?.size || "1.5em"}/></Box>,
    notesIcon: (props?: DashboardIconProps) => <Box style={centerAlignStyle} {...props} c={props?.c || DashboardColors.notes}><IconNotes
        size={props?.size || "1.5em"} /></Box>,
    trendingUpIcon: (props?: DashboardIconProps) => <Box style={centerAlignStyle} {...props} c={props?.c || DashboardColors.trendingUp}><IconActivity
        size={props?.size || "1.5em"}/></Box>,
    trendingDownIcon: (props?: DashboardIconProps) => <Box style={centerAlignStyle} {...props} c={props?.c || DashboardColors.trendingDown}><IconActivity
        size={props?.size || "1.5em"} /></Box>,
    activityIcon: (props?: DashboardIconProps) => <Box style={centerAlignStyle} {...props} c={props?.c || DashboardColors.activity}><IconActivity
        size={props?.size || "1.5em"}/></Box>,
    durationIcon: (props?: DashboardIconProps) => <Box style={centerAlignStyle} {...props} c={props?.c || DashboardColors.duration}><IconClock
        size={props?.size || "1.5em"} /></Box>,
    templateIcon: (props?: DashboardIconProps) => <Box style={centerAlignStyle} {...props} c={props?.c || DashboardColors.template}><IconTemplate
        size={props?.size || "1.5em"}/></Box>,
    fileTextIcon: (props?: DashboardIconProps) => <Box style={centerAlignStyle} {...props} c={props?.c || DashboardColors.fileText}><IconFileText
        size={props?.size || "1.5em"} /></Box>,
    sessionsIcon: (props?: DashboardIconProps) => <Box style={centerAlignStyle} {...props} c={props?.c || DashboardColors.sessions}><IconClock
        size={props?.size || "1.5em"}/></Box>,
    calendarIcon: (props?: DashboardIconProps) => <Box style={centerAlignStyle} {...props} c={props?.c || DashboardColors.calendar}><IconCalendar
        size={props?.size || "1.5em"}/></Box>,


}